import React from "react";
import ForgotPassword from "components/local/forgotPassword";

const ForgotPasswordPage = () => {
  return (
    <div>
      <ForgotPassword />
    </div>
  );
};

export default ForgotPasswordPage;
